import axios from "axios";
import { useEffect, useState } from "react";
import { formatToMMDDYYYY } from "../../../../../utils/dates";
import { Receipt } from "lucide-react";

export interface ComprobanteRow {
  venta_comprobante_id: number;
  fecha_creacion: string;
  estado: string;
  numero_factura?: string;
  producto_name?: string;
}

const RecentVentaComprobantes = () => {
  const [rows, setRows] = useState<ComprobanteRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      try {
        const response = await axios.get<ComprobanteRow[]>(
          `${process.env.REACT_APP_API_URL}/api/venta_comprobante/user/${sessionStorage.getItem("user_id")}`,
          {
            headers: { "auth-token": `${sessionStorage.getItem("token")}` },
          }
        );
        const sorted = [...response.data].sort(
          (a, b) =>
            new Date(b.fecha_creacion).getTime() -
            new Date(a.fecha_creacion).getTime()
        );
        setRows(sorted.slice(0, 5));
      } catch {
        setRows([]);
      } finally {
        setLoading(false);
      }
    };
    run();
  }, []);

  if (loading) {
    return (
      <div className="rounded-2xl border border-gray-200 bg-white p-4 text-sm text-gray-500">
        Cargando comprobantes…
      </div>
    );
  }

  if (rows.length === 0) {
    return (
      <div className="rounded-2xl border border-dashed border-gray-200 bg-white p-6 text-center">
        <p className="text-sm text-gray-600">Aún no hay comprobantes de venta</p>
        <p className="mt-1 text-xs text-gray-400">Registre una venta con el botón de arriba</p>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white">
      <div className="border-b border-gray-100 px-4 py-3">
        <h2 className="text-sm font-semibold text-gray-800">
          Últimos comprobantes
        </h2>
        <p className="text-xs text-gray-500">Venta y estado</p>
      </div>
      <ul className="divide-y divide-gray-100">
        {rows.map((c) => (
          <li
            key={c.venta_comprobante_id}
            className="flex items-start gap-3 px-4 py-3"
          >
            <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#205f43]/10 text-[#205f43]">
              <Receipt className="h-4 w-4" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-gray-900">
                {c.producto_name || c.numero_factura || "Venta"}
              </p>
              <p className="text-xs text-gray-500">
                {formatToMMDDYYYY(c.fecha_creacion)}
              </p>
            </div>
            <span
              className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ${
                c.estado === "Aprobado"
                  ? "bg-emerald-100 text-emerald-800"
                  : c.estado === "Rechazado"
                    ? "bg-red-100 text-red-800"
                    : "bg-amber-100 text-amber-900"
              }`}
            >
              {c.estado}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecentVentaComprobantes;
